<script>
  import { Link } from "svelte-routing";
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Mea+Culpa&display=swap');
html,body ,
h1{
	font: 400 2.615rem/2.675rem 'Mea Culpa', cursive;
}
h3{
	font: 400 2.415rem/2.475rem 'Mea Culpa', cursive;
}
h5{
	font: 400 2.015rem/2.075rem 'Mea Culpa', cursive;
}
	p {
	font: 100 1.615rem/1.675rem 'Mea Culpa', cursive;
}	j {
	font: 100 1.815rem/1.875rem 'Mea Culpa', cursive;
}
</style> 
        <div 
		style="background-image: url(https://mesinkasir.github.io/larapos/img/wedding/weddingonline.jpg);
		background-repeat: no-repeat;
		background-attachment: fixed;
  background-position: center; 
   background-size: cover;
		"
		>
           <div class="container">
		   <div class="row py-5">
		   <div class="col-12 p-3 p-md-5 text-center"></div>
		   <div class="col-12 p-3 p-md-5">
		   <div class="bg-white rounded shadow p-3 p-md-5 text-center" style="opacity:0.8;">
		   <h1>- Information -</h1>
		   <p>Click pada menu dibawah ini untuk detail informasi</p>
		   <div class="row">
		   <Link to="/acara" class="btn col-12 col-md-4 p-3">
		   <div class="p-3 border border-danger">
		   <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" fill="currentColor" class="bi bi-calendar-event text-danger" viewBox="0 0 16 16">
  <path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"/>
  <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
</svg>
		    <p class="p-1"><strong>Acara</strong></p>
		   </div>
		   </Link>
		   <Link to="/map" class="btn col-12 col-md-4 p-3">
		   <div class="p-3 border border-info">
		   <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" fill="currentColor" class="bi bi-map text-info" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M15.817.113A.5.5 0 0 1 16 .5v14a.5.5 0 0 1-.402.49l-5 1a.502.502 0 0 1-.196 0L5.5 15.01l-4.902.98A.5.5 0 0 1 0 15.5v-14a.5.5 0 0 1 .402-.49l5-1a.5.5 0 0 1 .196 0L10.5.99l4.902-.98a.5.5 0 0 1 .415.103zM10 1.91l-4-.8v12.98l4 .8V1.91zm1 12.98 4-.8V1.11l-4 .8v12.98zm-6-.8V1.11l-4 .8v12.98l4-.8z"/>
</svg>
		   <p class="p-1"><strong>Maps</strong></p>
		   </div>
		   </Link>
		   <a href="https://wa.me/+6285646104747" class="btn col-12 col-md-4 p-3">
		   <div class="p-3 border border-success">
		   <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" fill="currentColor" class="bi bi-whatsapp text-success" viewBox="0 0 16 16">
  <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"/>
</svg>
		   <p class="p-1"><strong>Whatsapp</strong></p>
		   </div>
		   </a>
		   </div>
		   <p>
		   Kami sangat mengharapkan kehadiran anda di acara resepsi kami.<br/>
		   William Tanujaya & Ina Indrasari
		   </p>
		   </div>
		   </div>
		   </div>
		   </div>
		    <div class="col-12 p-1 text-center">
			<small>wedding online <a href="https://creativebydre.vercel.app">creative by dre</a></small>
			</div>
    </div>
